import Navbar from "../../../components/Navbar/Navbar";
import NoteAuditReportList from "../components/NoteAuditReportList/NoteAuditReportList";

export default function NoteAuditReportPage() {
    return (
        <>
            <Navbar title="Auditing Report" />
            <NoteAuditReportList />
        </>
    );
}
